export const state = {
  // the interface language (one locale per language, e.g. EN_US)
  locale: null,
  // the regional format for dates and amounts (e.g. EN_GB), independent of the language
  formatLocale: null,
  availableTranslations: [],
};

export default function isNewTranslation(state, translationKey) {
  return state.availableTranslations.find((translation) => translation.key === translationKey);
}

export const mutations = {
  SET_LOCALE(state, payload) {
    state.locale = payload;
  },

  SET_FORMAT_LOCALE(state, payload) {
    state.formatLocale = payload;
  },

  SET_AVAILABLE_TRANSLATION(state, payload) {
    if (isNewTranslation(state, payload) === undefined) {
      state.availableTranslations.push(payload);
    }
  },

  CLEAR_AVAILABLE_TRANSLATION(state) {
    state.availableTranslations = [];
  },
};
